import { AxiosResponse } from "axios";

import API from "../api";
import { Job } from "../models/job";
import BaseService from "./_base.service";

const ROUTE_NAME = "jobs";

interface JobIdAxiosResponse<T> extends AxiosResponse<T> {
  jobId: number;
}

const JobService = {
  ...BaseService<Job>({ endpoint: ROUTE_NAME }),
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(job: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, job);
  },
  async update(id: number, job: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, job);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async delivery(id: number): Promise<AxiosResponse<any>> {
    return await API.put(`/${ROUTE_NAME}/delivery/${id}`);
  },
  async generateInventoryReport(id: number): Promise<JobIdAxiosResponse<any>> {
    const response = await API.get(`/${ROUTE_NAME}/reports/inventory/${id}`, {
      timeout: 0,
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    });
    return { ...response, jobId: id };
  },

  async searchByReference(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/search/by/reference`, { params: options });
  },

  async getEstimates(id?: number | string): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/estimate/${id}`);
  },

  async getAllAndCountBySubcontractor(
    options?: any
  ): Promise<AxiosResponse<{ count: number; rows: Job[] }>> {
    return await API.get(`/${ROUTE_NAME}/subcontractor/list`, { params: options });
  },
};

export default JobService;
